import { Start } from 'base/src/main.tsx'
import { sideBarOptions } from './infra/routes/sideBarOptions.ts'
import { LangList } from 'base/i18n.ts'
import CarteiraBaseProvider from 'domain/utils/context/carteiraBaseContext';
import { CAMPANHA_URL } from 'domain/infra/data/env';

import translationEN from "./lang/en/translation.json";
import translationPT from "./lang/pt/translation.json";
import { CampanhaRouter } from './infra/routes/campanhaRoutes.tsx';
import { CampanhaReducerList } from './store/campanhaReducer.ts';
import { CarteiraValor } from 'domain/components/_carteira';
import { registerCampanhaAuthInterceptor } from './infra/auth/campanhaAuthInterceptor.ts';

const langList:LangList={
    en:translationEN,
    pt:translationPT
}

registerCampanhaAuthInterceptor();

Start({
    headerLeftInfo: <CarteiraValor />,
    sistemaID:7,
    storeRoot: CampanhaReducerList,
    routes: CampanhaRouter,
    sidebarOptions: sideBarOptions,
    langList: langList,
    titulo: "Campanha",
    customWrapper: CarteiraBaseProvider,
    accessTokenRequiredClaims: ['UsuarioID', 'CampanhaID', 'EmpresaID'],
    accessTokenValidatorUrl: `${CAMPANHA_URL}/oauth2/validate`,
})